
import { computed, defineComponent, reactive, ref } from 'vue'
import { IonPage, IonContent, IonList, IonButton, IonInput, IonItem, IonCheckbox, IonLabel, IonText } from '@ionic/vue';
import { useStore } from 'vuex';
import { useVuelidate } from '@vuelidate/core'
import { minLength, email, required } from '@vuelidate/validators'

export default defineComponent({
    name: 'Authentication',
    components: { IonPage, IonContent, IonButton, IonList, IonInput, IonItem, IonCheckbox, IonLabel, IonText },
    setup() {
        const store = useStore()
        const isLoading = computed(() => store.getters.isLoading)
        const showSignUp = ref(true)

        const authData = reactive({
            name: "",
            email: "",
            password: ""
        })

        const termsAccepted = ref(false)

        const requiredPasswordLength = 8
        const rules = computed(() => ({
            name: {
                required,
                $autoDirty: true
            },
            email: {
                required,
                email,
                $autoDirty: true
            },
            password: {
                required,
                minLength: minLength(requiredPasswordLength),
                $autoDirty: true
            }
        }))

        const v$ = useVuelidate(rules as any, authData)

        const onSignUp = () => {
            v$.value.$touch()
            if(v$.value.$error) return

            store.dispatch('signUserUp', authData).then(() => {
                authData.name = ""
                authData.email = ""
                authData.password = ""
                v$.value.$reset()
            })
        }

        const onSignIn = () => {
            if (authData.email && authData.password) {
                store.dispatch('signUserIn', { email: authData.email, password: authData.password }).then(() => {
                    authData.email = ""
                    authData.password = ""
                    v$.value.$reset()
                })
            }
        }

        return { isLoading, showSignUp, authData, termsAccepted, onSignUp, onSignIn, v$ }
    },
})
